/* eslint-disable no-unused-vars */
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.config({
  autoSleep: 60,
  force3D: true,
  nullTargetWarn: false,
  trialWarn: false,
  units: {
    left: '%',
    top: '%',
    rotation: 'rad',
  },
});
gsap.registerPlugin(ScrollTrigger);

export default {
  data() {
    return {
      about_tl: null,
    };
  },
  methods: {
    SetPageEnterGsap() {
      this.about_tl != null ? this.about_tl.kill() : '';
      let page = document.querySelector('#HomeAbout');
      let motor_image = page.querySelector('.motor_image');
      let title = page.querySelector('.title span');
      let title_bg = page.querySelector('.title_bg');
      let sub_title_line = page.querySelector('.sub_title_line');
      let sub_title_text = page.querySelector('.sub_title_text span');
      let content = page.querySelector('.content');
      let more_btn_box = page.querySelector('.more_btn_box');

      let about_tl = gsap.timeline({
        scrollTrigger: {
          trigger: page,
          start: 'top 85%',
          toggleActions: 'restart play play reverse',
        },
      });

      let motor_tl = gsap.timeline({
        scrollTrigger: {
          trigger: page,
          start: 'top 85%',
          end: 'center center',
          scrub: true,
        },
      });
      motor_tl.fromTo(
        motor_image,
        {
          x: '-100%',
        },
        {
          x: '0%',
        }
      );

      about_tl.fromTo(
        title,
        {
          opacity: 1,
          y: '200%',
        },
        {
          opacity: 1,
          y: '0%',
          duration: 0.4,
          ease: 'circ.inOut',
        },
        0
      );
      about_tl.fromTo(
        title_bg,
        {
          opacity: 1,
          transformOrigin: 'left',
          scaleX: 0,
        },
        {
          opacity: 1,
          transformOrigin: 'left',
          scaleX: 1,
          delay: 0.4,
          ease: 'back.out(1.7)',
        },
        0
      );
      about_tl.fromTo(
        sub_title_line,
        {
          transformOrigin: 'left',
          opacity: 1,
          scaleX: 0,
        },
        {
          transformOrigin: 'left',
          opacity: 1,
          scaleX: 1,
          delay: 1,
          duration: 0.6,
        },
        0
      );
      about_tl.fromTo(
        sub_title_text,
        {
          opacity: 1,
          x: '-101%',
        },
        {
          opacity: 1,
          x: '0%',
          delay: 1.6,
          duration: 0.4,
        },
        0
      );
      about_tl.fromTo(
        content,
        {
          opacity: 0,
          y: '20px',
        },
        {
          opacity: 1,
          y: '0px',
          delay: 1,
          duration: 0.4,
        },
        0
      );
      about_tl.fromTo(
        more_btn_box,
        {
          opacity: 0,
          x: '-20px',
        },
        {
          opacity: 1,
          x: '0px',
          delay: 1.6,
          duration: 0.4,
        },
        0
      );
    },
  },
  watch: {
    page_image_loaded() {
      if (this.page_image_loaded == true && this.page_data != null) {
        this.$nextTick(() => {
          this.SetPageEnterGsap();
        });
      }
    },
    page_data() {
      if (this.page_image_loaded == true && this.page_data != null) {
        this.$nextTick(() => {
          this.SetPageEnterGsap();
        });
      }
    },
  },
  computed: {
    page_image_loaded() {
      return this.$store.state.page_image_loaded;
    },
  },
  mounted() {
    clearTimeout(this.carousel_timer);
  },
  beforeDestory() {
    clearTimeout(this.carousel_timer);
    this.active_carousel = 0;
  },
};
